module.exports = __webpack_public_path__ + "img/gas_valve.f2bb924e.svg";